'use strict';

const { hydrate } = require('@grpn/hydration');
const { connect } = require('preact-redux');

const OfferRedemptionText = require('../../shared/views/offer/offer-redemption-text');
const Link = require('../../../components/link');
const redemptionHandler = require('../../support/redemption-handler');
const { publish } = require('../../support/event-observer');
const { getReferralSource } = require('../../support/redemption-helper');

function getAnchorContent(className, offerType) {
  if (className === 'coupon-tile-background') {
    return null;
  }

  return OfferRedemptionText({
    type: offerType,
  });
}

function CouponButton({
  coupon,
  routes,
  className = '',
  referralSource,
  directRedemption,
  showDisruptor,
  merchantName = '',
  emailCTAExperiment: { name } = {},
}) {
  const { offerId, offerType } = coupon;

  referralSource = getReferralSource({
    referralSource,
    offerId,
    directRedemption,
  });

  const clickRedemptionHandler = () => {
    const redemptionData = {
      routes,
      offerId,
      referralSource,
      merchantName,
      offerType,
    };

    if (showDisruptor) {
      publish('@redemption', {
        ...redemptionData,
        type: 'DISRUPT',
      });
    } else {
      redemptionHandler(redemptionData).then(data =>
        publish('@redemption', data)
      );
    }
  };

  const keyUpRedemptionHandler = ev => {
    if (ev.keyCode === 13) {
      clickRedemptionHandler();
    }
  };

  return Link({
    className,
    experimentName: name,
    attributes: {
      tabindex: 0,
      onClick: clickRedemptionHandler,
      onKeyUp: keyUpRedemptionHandler,
      'data-bhc': `coupon:${offerId}`,
      'data-bhd': JSON.stringify({ type: offerType }),
    },
    text: getAnchorContent(className, offerType),
  });
}

const mapStateToProps = state => ({
  referralSource: state.referralSource,
  directRedemption: state.directRedemption,
  showDisruptor: state.showDisruptor,
  merchantName: state.merchantName,
  emailCTAExperiment: state.emailCTAExperiment,
});

module.exports = connect(mapStateToProps)(
  hydrate('CouponButton', CouponButton)
);
